import React, { useRef } from 'react';
import { Button } from 'react-bootstrap';
import { useText } from '../context/TextContext';

interface Props {
    files: File[];
    onFilesChange: (files: File[]) => void;
    onFileSelect: (files: File[]) => void;
    disabled?: boolean;
}

export default function CommentAttachments({ files, onFilesChange, onFileSelect, disabled }: Props) {
    const text = useText();
    const fileInputRef = useRef<HTMLInputElement>(null);

    const handleFileInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const selectedFiles = e.target.files;
        if (!selectedFiles || selectedFiles.length === 0) return;

        const fileArray = Array.from(selectedFiles).filter(file => file.type.startsWith('image/'));

        if (fileArray.length > 0) {
            onFileSelect(fileArray);
        }

        // Reset the input
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };

    const handleRemoveFile = (fileIndex: number) => {
        const updatedFiles = files.filter((_, i) => i !== fileIndex);
        onFilesChange(updatedFiles);
    };

    return (
        <div className="d-flex align-items-center gap-2">
            <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileInputChange}
                accept="image/*"
                multiple
                style={{ display: 'none' }}
            />

            {/* File previews */}
            {files.map((file, index) => {
                const previewUrl = URL.createObjectURL(file);
                return (
                    <div key={index} className="position-relative">
                        <div
                            className="border rounded overflow-hidden"
                            style={{ width: '24px', height: '24px' }}
                        >
                            <img
                                src={previewUrl}
                                alt={file.name}
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover'
                                }}
                            />
                        </div>
                        {!disabled && (
                            <Button
                                variant="danger"
                                size="sm"
                                className="position-absolute top-0 end-0 rounded-circle p-0 d-flex align-items-center justify-content-center"
                                style={{
                                    width: '14px',
                                    height: '14px',
                                    marginTop: '-4px',
                                    marginRight: '-4px',
                                    fontSize: '8px'
                                }}
                                onClick={() => handleRemoveFile(index)}
                            >
                                <i className="bi bi-x"></i>
                            </Button>
                        )}
                    </div>
                );
            })}

            {/* Attachment icon */}
            {!disabled && (
                <button
                    type="button"
                    onClick={() => fileInputRef.current?.click()}
                    className="btn btn-link p-0 text-muted"
                    style={{ border: 'none', background: 'none' }}
                    title={text.addAttachment || 'Add image'}
                >
                    <i className="bi bi-paperclip" style={{ fontSize: '14px' }}></i>
                </button>
            )}
        </div>
    );
}